<template>
    <DModal
        :show="showModal"
        :is-error="true"
        :title="exception?.title"
        :message="exception?.body"
        :error="exception?.error"
        :link-message="exception?.linkMessage"
        :link="exception?.link"
        :error-trace="exception?.errorTrace"
        is-big
    />
</template>

<script setup>
defineProps({
    exception: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    }
})

defineEmits(['close-modal'])
</script>

<style scoped>
</style>
